<template>
  <v-layout wrap v-if="typesActivity && content">
    <v-flex xs12 style="margin-top:10px;">
      <v-select
        v-if="typesActivity"
        outlined
        hide-details
        v-model="content.TypeActivity"
        :items="typesActivity"
        item-text="Name"
        item-value="ID"
        :label="$t('dtouch.activities.types', locale)"
        @change="handleChangeIsModified"
      />
    </v-flex>
    <v-flex xs12 style="margin-top: 10px;">
      <color-picker-item
        :value="content.ActivityPrimaryColor"
        :label="$t('dtouch.activities.primaryColor', locale)"
        :onChange="handleChangePrimaryColor"
        borderRadius="20px 0 0 0"
      />
    </v-flex>
    <v-flex xs12>
      <color-picker-item
        :value="content.ActivitySecundaryColor"
        :label="$t('dtouch.activities.secondaryColor', locale)"
        :onChange="handleChangeSecundaryColor"
        borderRadius="0 0 0 0"
      />
    </v-flex>
    <v-flex xs12>
      <color-picker-item
        :value="content.ActivityColor"
        :label="$t('dtouch.activities.titleColor', locale)"
        :onChange="handleChangeTitleColor"
        borderRadius="0 0 0 0"
      />
    </v-flex>
    <v-flex xs12>
      <color-picker-item
        :value="content.ActivityDescriptionColor"
        :label="$t('dtouch.activities.descriptionColor', locale)"
        :onChange="handleChangeDescriptionColor"
        borderRadius="0 0 20px 0"
      />
    </v-flex>

  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
//import axios from 'axios'
import utils from '@/services/utils'
import api from '@/services/api'
import ColorPickerItem from '@/components/common-components/ColorPickerItem'
export default {
  name: 'Form13Activities',
  components: {
    ColorPickerItem,
  },
  props: {
    editedItem: {
      type: Object,
      required: true
    },
    onChangeIsModified: {
      type: Function,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    content: null,
    typesActivity: null,
  }),
  computed: {        
    ...mapState('app', ['locale']),
    workspaceID () {
      return utils.getWorkspace('dtouch')
    },
  },
  watch: {
    editedItem () {
      this.prepareContent()
    },
  },
  mounted () {
    this.handleGetTypesActivity()
    this.prepareContent()
  },
  methods: {
    prepareContent () {
      const aux = this.editedItem
      this.content = aux
    },
    handleChangeIsModified () {
      this.onChangeIsModified(this.content) 
    },
    handleGetTypesActivity () {
      api.getAll('dtouch', `v1/private/workspaces/${this.workspaceID}/activities-types`).then(response => {
        this.typesActivity = response.types
      })
    },
    handleChangePrimaryColor (v) {
      this.content.ActivityPrimaryColor = v
      this.handleChangeIsModified()
    },
    handleChangeSecundaryColor (v) {
      this.content.ActivitySecundaryColor = v
      this.handleChangeIsModified()
    },
    handleChangeTitleColor (v) {
      this.content.ActivityColor = v
      this.handleChangeIsModified()
    },
    handleChangeDescriptionColor (v) {
      this.content.ActivityDescriptionColor = v
      this.handleChangeIsModified()
    },
  },
}
</script>

